import {get, post} from '../interceptor'
let preUrl = '/myApi/sys'

export default {
  loginIn (params) { return post(preUrl, '/login', params) }
}



// WEBPACK FOOTER //
// ./src/api/company/systemManage.js